import type {
  CoverageActivityRange,
  CoverageFilter,
  FetchCoverageActivityParams,
  FetchCoverageAssetsParams,
  FetchCoverageHubsParams,
  FetchCoverageWorkFilesParams,
} from "./types";

/**
 * Feature-local query-key factory.
 * Hierarchy: all → board(slug) → summary | hubs | activity | hub | assets | workFiles
 */
export const coverageKeys = {
  all: ["coverage"] as const,

  board: (slug: string) => [...coverageKeys.all, slug] as const,

  summary: (slug: string) => [...coverageKeys.board(slug), "summary"] as const,

  hubs: (slug: string, params: FetchCoverageHubsParams) =>
    [...coverageKeys.board(slug), "hubs", params] as const,

  activity: (slug: string, params: FetchCoverageActivityParams) =>
    [...coverageKeys.board(slug), "activity", params] as const,

  hub: (slug: string, hubId: number) =>
    [...coverageKeys.board(slug), "hub", hubId] as const,

  assets: (slug: string, hubId: number, params: FetchCoverageAssetsParams) =>
    [...coverageKeys.board(slug), "hub", hubId, "assets", params] as const,

  workFiles: (slug: string, hubId: number, params: FetchCoverageWorkFilesParams) =>
    [...coverageKeys.board(slug), "hub", hubId, "work-files", params] as const,
} as const;

/** Map UI filter pills → hubs list query params (server-driven). */
export function hubsParamsForFilter(
  filter: CoverageFilter,
  search: string,
  offset = 0,
  limit = 50
): FetchCoverageHubsParams {
  const trimmed = search.trim();
  const base: FetchCoverageHubsParams = {
    limit,
    offset,
    ...(trimmed ? { search: trimmed } : {}),
  };

  if (filter === "output_ready") return { ...base, output_ready: true };
  if (filter === "partial") return { ...base, status: "partial" };
  if (filter === "empty") return { ...base, status: "empty" };
  if (filter === "sequence_ready") return { ...base, sequence_status: "sequence_ready" };
  return base;
}

export function activityParamsForRange(
  range: CoverageActivityRange,
  offset = 0,
  limit = 10
): FetchCoverageActivityParams {
  return { range, limit, offset };
}
